import React from 'react'
import { Divider, Grid } from "@mui/material"

import {
	AlertsBaseDrawer,
	AlertsComparisonType,
	AlertsConditionName,
	AlertsDrawerBaseFooter,
	AlertsMoreFeatures
} from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import AlertsMainSites from "Pages/ReportsAlerts/Alerts/Conditions/NoAvailability/Drawer/MainSites"
import Providers from "Pages/ReportsAlerts/Alerts/Conditions/NoAvailability/Drawer/Providers"
import NotifyAvailability from "Pages/ReportsAlerts/Alerts/Conditions/NoAvailability/Drawer/NotifyAvailability"


export default function NoAvailabilityDrawer({ onSubmitAlert, isLoading }) {

	return <AlertsBaseDrawer
		footer={<AlertsDrawerBaseFooter isLoading={isLoading} onSubmitAlert={onSubmitAlert}/>}
		content={<Grid container spacing={2}>
			<Grid item xs={12} data-tour-id="cond-na-name">
				<AlertsConditionName/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ my: 1 }}/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-na-main-site">
				<AlertsMainSites/>
			</Grid>
			<Grid item xs={12}/>
			<Grid item xs={12} data-tour-id="cond-na-providers">
				<Providers providersLabel="Providers not available" tiersLabel="Tiers not available"/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ my: 1 }}/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-na-comp-type">
				<AlertsComparisonType/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ my: 1 }}/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-na-notify">
				<NotifyAvailability/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ my: 1 }}/>
			</Grid>
			<Grid item xs={12} data-tour-id="cond-na-more">
				<AlertsMoreFeatures/>
			</Grid>
		</Grid>
		}
	/>
}